export default __webpack_public_path__ + "static/media/E-1BD main cover.6208b2b7.jpg";